import React from 'react';
import { AuthPage } from '@refinedev/antd';
import { Typography, Space } from 'antd';
import { HeartOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

// Simple Clinovia Title Component
const ClinoviaTitle: React.FC = () => {
  return (
    <div style={{ textAlign: 'center', marginBottom: '24px' }}>
      <Space direction="vertical" size={16} align="center">
        {/* Logo and Main Title */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '48px',
              height: '48px',
              borderRadius: '12px',
              background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
              boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <HeartOutlined
              style={{
                fontSize: '24px',
                color: '#ffffff',
                zIndex: 2,
                position: 'relative',
              }}
            />
            {/* Subtle glow effect */}
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '100%',
                height: '100%',
                background: 'radial-gradient(circle, rgba(255,255,255,0.2) 0%, transparent 70%)',
                borderRadius: '50%',
              }}
            />
          </div>
          <div>
            <Title
              level={1}
              style={{
                margin: 0,
                background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                fontSize: '36px',
                fontWeight: 700,
                letterSpacing: '-1px',
                lineHeight: 1.2,
              }}
            >
              Clinovia
            </Title>
          </div>
        </div>
        
        {/* Subtitle */}
        <div style={{ textAlign: 'center' }}>
          <Text
            style={{
              fontSize: '16px',
              color: '#666',
              fontWeight: 500,
              letterSpacing: '0.5px',
            }}
          >
            Advanced Healthcare Management System
          </Text>
        </div>
        
        {/* Tagline */}
        <div style={{ textAlign: 'center' }}>
          <Text
            style={{
              fontSize: '14px',
              color: '#999',
              fontStyle: 'italic',
            }}
          >
            Empowering healthcare professionals with intelligent solutions
          </Text>
        </div>
      </Space>
    </div>
  );
};

export const Login: React.FC = () => {
  return (
    <AuthPage
      title={<ClinoviaTitle />}
      forgotPasswordLink={false} // hides "Forgot password?"
      registerLink={false}
      rememberMe={false}
      type="login"
    />
  );
};
